module.exports = __webpack_public_path__ + "img/Slider2.c43eccf1.svg";